import * as actionTypes from './actionTypes'

export function updateFieldWarning(warnings) {
  return {
    type: actionTypes.UPDATE_FIELD_WARNINGS,
    warnings
  }
}

export function updateFieldValidationObject(field) {
  return {
    type: actionTypes.UPDATE_FIELD_VALIDATION_OBJECT,
    field
  }
}
